//MUI :
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getFormulesEleves, getEleves, getResa } from "../../store/selectors.js";

//utils
import getTotalResa from '../../utils/total_resa.js';

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function CalendarCart() {

    const lang = useSelector(getLang) //global state : language
    let formulesEleves = useSelector(getFormulesEleves);
    let elevesList = useSelector(getEleves);
    //console.log(formulesEleves);

    // if editResa Mode :
    let allResaInfos = useSelector(getResa);
    let modifMode = false;
    if (allResaInfos.CreneauEleves) { modifMode = allResaInfos.CreneauEleves.length > 0; }


    function getAmount() {
        if (elevesList.length <= 0 || elevesList === undefined) { return; } //stop function if list is not already filled

        if (modifMode === true) {
            let initial = getTotalResa(formulesEleves, elevesList);
            let couponed = (100 - allResaInfos.coupon) / 100 * initial;
            return (Math.round(couponed) + ",00 €");

        }
        else {
            return (getTotalResa(formulesEleves, elevesList) + ",00 €");
        }

    }

    function getRawAmount() {

        if (elevesList.length <= 0 || elevesList === undefined) { return; } //stop function if list is not already filled

        if (modifMode === true && allResaInfos.coupon > 0) {
            let initial = getTotalResa(formulesEleves, elevesList);
            return (initial + ",00 €");
        }
        else {
            return ("");
        }
    }

    return (

        <div className="calendar-cart">
            <div className="calendar-cart-infos">
                <ShoppingCartIcon className="calendar-cart-infos-cart" />
                <p className="calendar-cart-infos-montant">{modifMode === true ? "Montant du panier :" : translator("Montant de votre panier :", lang, "calendarCart")}</p>
                <p className="calendar-cart-infos-total">{getAmount()}<span>{getRawAmount()}</span></p>
            </div>
        </div>
    );
}

export default CalendarCart;